export default "__VITE_ASSET__DbDuGVPh__"